<template>
    <div>
        <RouterView/>
    </div>
</template>

<script>
import AuthService from './services/auth.service';

export default {
    name: 'App',
    metaInfo: {
      title: 'Iffent',
      titleTemplate: '%s | Iffent',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          property: 'og:title',
          content: 'Iffent',
          template: chunk => `${chunk} - Iffent`,
          vmid: 'og:title'
        },
        { name: 'og:locale', content: 'et_EE' },
        { name: 'og:site_name', content: 'Iffent' },
        {
          property: 'robots',
          content: 'noindex, nofollow',
          template: chunk => `${chunk}`,
          vmid: 'robots'
        },
      ]
    },
    mounted() {
        if(AuthService.isAuthorized) {
            this.$store.dispatch('global/getUser');
        }
    },
}
</script>

<style scoped>

</style>
